<ng-container #container></ng-container>
<button
  *ngIf="basePanelService.routeData?.isClose"
  class="ml-4"
  tuiIconButton
  type="button"
  appearance="outline"
  [icon]="icon"
  (click)="back()"
></button>
<ng-template #icon>
  <svg-icon [src]="'/assets/img/ic-close.svg'"></svg-icon>
</ng-template>
